import React from "react";
import { useUiPack } from "@/hooks/useUiPack";
import KitchenDisplay from "@/pages/KitchenDisplay";
import SimpleKitchen from "@/pages/simple/SimpleKitchen";

export default function UiPackKitchen() {
  const { isSimple } = useUiPack();
  return isSimple ? <SimpleKitchen /> : <KitchenDisplay />;
}
